
import vue from '../../adapter-vue';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import {
  TUITranslateService,
  IMessageModel,
  TUIChatService,
  TUIStore,
  StoreName,
} from '@tencentcloud/chat-uikit-engine';
import { isPC } from '../../utils/env';
import Icon from '../common/Icon.vue';
import emojiDel from '../assets/icon/emoji-del.svg';

interface Props {
  message: IMessageModel;
  emojiConfig: Record<string, any>;
}

const { ref, onMounted, computed } = vue;

export default {
  components: {
    Icon,
  },
  props: {
    message: {
      type: Object as () => IMessageModel,
      default: () => ({}),
    },
    emojiConfig: {
      type: Object as () => Record<string, any>,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    const { message, emojiConfig } = props;
    const currentUserID = ref<string>('');
    const emojiDetailRef = ref<HTMLElement | null>();
    const isShowDetail = ref<boolean>(false);
    const selectedReactionID = ref<string>('');
    const selectedReactionMessageID = ref<string>('');
    const userListOfMessageReaction = ref<Array<Record<string, any>>>([]);
    const isShowEmojiReaction = computed(() => props.message?.reactionList.some(item => item.totalUserCount !== 0));
    const reactionList = ref<any[]>([]);
    TUIStore.watch(StoreName.USER, {
      userProfile: (profile: any) => {
        currentUserID.value = profile?.userID;
      },
    });
    onMounted(() => {
      TUIStore.watch(StoreName.CUSTOM, {
        selectedReactionMessageID: (messageID: string) => {
          isShowDetail.value = message.ID === messageID ? true : false;
        },
      });
      // watch current conversationID
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: () => {
          TUIStore.update(StoreName.CUSTOM, 'selectedReactionMessageID', '');
        },
      });
    });
    // 展示表情回应详情
    const showReactionDetail = (reactionID: string, messageID: string) => {
      onClickOutside(emojiDetailRef?.value);
      TUICore.callService({
        serviceName: TUIConstants.TUIChat.SERVICE.NAME,
        method: TUIConstants.TUIChat.SERVICE.METHOD.CLOSE_MESSAGE_POP_MENU,
        params: {},
      });
      selectedReactionID.value = reactionID;
      TUIStore.update(StoreName.CUSTOM, 'selectedReactionMessageID', messageID);
      if (!isShowDetail.value) return;
      getAllUserListOfMessageReaction(reactionID);
    };

    // 获取切换的 emoji 详情
    const getToggledEmojiDetail = (reactionID: string) => {
      selectedReactionID.value = reactionID;
      getAllUserListOfMessageReaction(reactionID);
    };
    const showEmoji = (reactionID: string) => {
      return `${emojiConfig.emojiBaseUrl}${emojiConfig.emojiUrlMapping[reactionID]}`;
    };
    const getReactContent = (partialUserList: [], totalUserCount: number) => {
      // 同一个表情多人回复的时候，显示前 3 人
      const userList = partialUserList.slice(0, 3);
      const reactUserList = [];
      let reactContent = '';
      userList.forEach((item) => {
        let nick = item.nick || item.userID;
        if (nick.length > 10) {
          nick = `${nick.substring(0, 10)}...`;
        }
        reactUserList.push(nick);
      });

      reactContent = reactUserList.join(',');
      if (totalUserCount < 4) {
        return reactContent;
      }
      return `${reactContent}...${TUITranslateService.t('TUIChat.等')} ${totalUserCount} ${TUITranslateService.t('TUIChat.人')}`;
    };
    const removeMessageReaction = () => {
      const _message = TUIStore.getMessageModel(message.ID);
      TUIChatService.removeMessageReaction(_message, selectedReactionID.value);
      selectedReactionID.value = '';
    };

    const getAllUserListOfMessageReaction = async (reactionID: string) => {
      const options = {
        message: TUIStore.getMessageModel(message.ID),
        reactionID,
        nextSeq: 0,
        count: 100,
      };
      const allUserList = await TUIChatService.getAllUserListOfMessageReaction(options);
      userListOfMessageReaction.value = allUserList.data.userList;
      const reactionIndexByMe = userListOfMessageReaction.value.findIndex(
        item => item.userID === currentUserID.value,
      );
      if (reactionIndexByMe < 0) {
        return;
      }
      const reactionElement = userListOfMessageReaction.value.splice(reactionIndexByMe, 1)[0];
      reactionElement.reactedByMyself = true;
      userListOfMessageReaction.value = [
        reactionElement,
        ...userListOfMessageReaction.value,
      ];
    };

    // click outside
    let clickOutside = false;
    let clickInner = false;
    const onClickOutside = (component: any) => {
      document.addEventListener('mousedown', onClickDocument);
      component?.addEventListener && component?.addEventListener('mousedown', onClickTarget);
    };

    const removeClickListener = (component: any) => {
      document.removeEventListener('mousedown', onClickDocument);
      component?.removeEventListener && component?.removeEventListener('mousedown', onClickTarget);
    };

    const onClickDocument = () => {
      clickOutside = true;
      if (!clickInner && clickOutside) {
        isShowDetail.value = false;
        removeClickListener(emojiDetailRef?.value);
      }
      clickOutside = false;
      clickInner = false;
    };

    const onClickTarget = () => {
      clickInner = true;
    };

    const closeDetail = () => {
      if (!isPC) {
        isShowDetail.value = false;
      }
    };

    return {
      props,
      reactionList,
      currentUserID,
      emojiDetailRef,
      isShowDetail,
      selectedReactionID,
      selectedReactionMessageID,
      userListOfMessageReaction,
      isShowEmojiReaction,
      onClickTarget,
      onClickDocument,
      removeClickListener,
      getAllUserListOfMessageReaction,
      removeMessageReaction,
      showReactionDetail,
      getToggledEmojiDetail,
      getReactContent,
      showEmoji,
      closeDetail,
      isPC,
      emojiDel,
    };
  },
};

